import type { ReactNode } from 'react';
import { cx } from './cx';

export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

/** A short status or label. Statuses always say the word: “Live”, “In review”. */
export function Badge({
  tone = 'neutral',
  dot,
  className,
  children,
}: {
  tone?: Tone | 'brand' | 'outline';
  dot?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span className={cx('mz-badge', tone !== 'neutral' && `mz-badge-${tone}`, className)}>
      {dot && <span className="mz-badge-dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
